import { Facebook, Link2, MessageCircle, Twitter } from "lucide-react";
import { toast } from "sonner";

export const shareUrl = (token) => `${window.location.origin}/published/${token}`;

export const ShareButtons = ({ c }) => {
  const url = shareUrl(c.token);
  const text = `${c.reason === "complete" ? "I just finished" : "I just published"} "${c.title}"${c.author ? ` by ${c.author}` : ""}!`;
  const e = encodeURIComponent;
  const links = [
    { id: "x", label: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${e(text)}&url=${e(url)}` },
    { id: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${e(url)}` },
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${e(`${text} ${url}`)}` },
  ];
  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success("Link copied"); } catch { toast.error("Couldn't copy — select the link and copy it"); } };
  return (
    <div className="space-y-3" data-testid="share-buttons">
      <div className="flex flex-wrap gap-2">
        {links.map(({ id, label, icon: Icon, href }) => (
          <a key={id} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-${id}`}
            className="inline-flex items-center gap-2 h-9 px-4 rounded-full border border-slate-700 text-sm text-slate-200 hover:border-amber-500/60 hover:bg-amber-500/10 transition-colors"><Icon size={15} />{label}</a>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <input readOnly value={url} onFocus={(ev) => ev.target.select()} className="flex-1 min-w-0 h-9 rounded-md bg-slate-900 border border-slate-700 px-3 text-xs font-mono text-slate-300" data-testid="share-link-input" />
        <button type="button" onClick={copy} className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-amber-600 hover:bg-amber-500 text-white text-xs transition-colors" data-testid="share-copy-link"><Link2 size={14} />Copy link</button>
      </div>
    </div>
  );
};
